import React from 'react';
import styled, { keyframes } from 'styled-components';

const dashAnimation = keyframes`
  from { stroke-dashoffset: 0; }
  to { stroke-dashoffset: 100; }
`;

const Overlay = styled.svg`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 4;
`;

const SelectionRect = styled.rect`
  fill: rgba(28, 143, 250, 0.15);
  stroke: #00429d;
  stroke-width: 1;
  stroke-dasharray: 10;
  animation: ${dashAnimation} 10s linear infinite reverse;
  rx: 2;
  ry: 2;
`;

interface Props {
  x: number;
  y: number;
  width: number;
  height: number;
}

export function ZoomSelectionOverlay({ x, y, width, height }: Props) {
  return (
    <Overlay aria-hidden="true">
      <SelectionRect x={x} y={y} width={width} height={height} />
    </Overlay>
  );
}
